import { ExtendedRoute, PERMISSION_ACCESS_ALL } from '@ideapa/app-common';
import {
  PERMISSION_ACCESS_ENTITY as ACCRUAL_CEP_ACCESS_PERMISSION,
  ENTITY as ACCRUAL_CEP_ENTITY,
  ENTITY_PLURAL as ACCRUAL_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-accrual-cep';
import {
  PERMISSION_ACCESS_ENTITY as ANALISI_BILANCIO_ACCESS_PERMISSION,
  ENTITY as ANALISI_BILANCIO_ENTITY,
  ENTITY_PLURAL as ANALISI_BILANCIO_ENTITY_PLURAL,
} from '@ideapa/app-shared-analisi-bilancio';
import {
  PERMISSION_ACCESS_ENTITY as ATTIVITA_PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as ATTIVITA_PARTECIPATA_ENTITY,
  ENTITY_PLURAL as ATTIVITA_PARTECIPATA_ENTITY_PLURAL,
} from '@ideapa/app-shared-attivita-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as BDAP_CEP_ACCESS_PERMISSION,
  ENTITY as BDAP_CEP_ENTITY,
  ENTITY_PLURAL as BDAP_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-bdap-cep';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_CONSOLIDATO_ACCESS_PERMISSION,
  ENTITY as BILANCIO_CONSOLIDATO_ENTITY,
  ENTITY_PLURAL as BILANCIO_CONSOLIDATO_ENTITY_PLURAL,
} from '@ideapa/app-shared-bilancio-consolidato';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_CONSOLIDATO_RIGA_ACCESS_PERMISSION,
  ENTITY as BILANCIO_CONSOLIDATO_RIGA_ENTITY,
  ENTITY_PLURAL as BILANCIO_CONSOLIDATO_RIGA_ENTITY_PLURAL,
} from '@ideapa/app-shared-bilancio-consolidato-riga';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ACCESS_PERMISSION,
  ENTITY as BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ENTITY,
  ENTITY_PLURAL as BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ENTITY_PLURAL,
} from '@ideapa/app-shared-bilancio-consolidato-riga-dettaglio';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_ENTE_ACCESS_PERMISSION,
  ENTITY as BILANCIO_ENTE_ENTITY,
} from '@ideapa/app-shared-bilancio-ente';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_ENTE_RIGA_ACCESS_PERMISSION,
  ENTITY as BILANCIO_ENTE_RIGA_ENTITY,
} from '@ideapa/app-shared-bilancio-ente-riga';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as BILANCIO_PARTECIPATA_ENTITY,
  ENTITY_PLURAL as BILANCIO_PARTECIPATA_ENTITY_PLURAL,
} from '@ideapa/app-shared-bilancio-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as BILANCIO_PARTECIPATA_RIGA_ACCESS_PERMISSION,
  ENTITY as BILANCIO_PARTECIPATA_RIGA_ENTITY,
  ENTITY_PLURAL as BILANCIO_PARTECIPATA_RIGA_ENTITY_PLURAL,
} from '@ideapa/app-shared-bilancio-partecipata-riga';
import {
  PERMISSION_ACCESS_ENTITY as CANCELLAZIONI_CEP_ACCESS_PERMISSION,
  ENTITY as CANCELLAZIONI_CEP_ENTITY,
  ENTITY_PLURAL as CANCELLAZIONI_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-cancellazioni-cep';
import {
  PERMISSION_ACCESS_ENTITY as CANCELLAZIONI_PARTECIPO_ACCESS_PERMISSION,
  ENTITY as CANCELLAZIONI_PARTECIPO_ENTITY,
  ENTITY_PLURAL as CANCELLAZIONI_PARTECIPO_ENTITY_PLURAL,
} from '@ideapa/app-shared-cancellazioni-partecipo';
import {
  PERMISSION_ACCESS_ENTITY as CHIUSURA_RIPRISTINO_CONSOLIDATO_ACCESS_PERMISSION,
  ENTITY as CHIUSURA_RIPRISTINO_CONSOLIDATO_ENTITY,
  ENTITY_PLURAL as CHIUSURA_RIPRISTINO_CONSOLIDATO_ENTITY_PLURAL,
} from '@ideapa/app-shared-chiusura-ripristino-consolidato';
import {
  PERMISSION_ACCESS_ENTITY as CHIUSURA_RIPRISTINO_ESERCIZIO_ACCESS_PERMISSION,
  ENTITY as CHIUSURA_RIPRISTINO_ESERCIZIO_ENTITY,
  ENTITY_PLURAL as CHIUSURA_RIPRISTINO_ESERCIZIO_ENTITY_PLURAL,
} from '@ideapa/app-shared-chiusura-ripristino-esercizio';
import {
  PERMISSION_ACCESS_ENTITY as COFI_ACCESS_PERMISSION,
  ENTITY as COFI_ENTITY,
  ENTITY_PLURAL as COFI_ENTITY_PLURAL,
} from '@ideapa/app-shared-cofi';
import {
  PERMISSION_ACCESS_ENTITY as COMPAGINE_SOCIALE_ACCESS_PERMISSION,
  ENTITY as COMPAGINE_SOCIALE_ENTITY,
  ENTITY_PLURAL as COMPAGINE_SOCIALE_ENTITY_PLURAL,
} from '@ideapa/app-shared-compagine-sociale';
import {
  PERMISSION_ACCESS_ENTITY as CONTI_NON_RACCORDATI_CEP_ACCESS_PERMISSION,
  ENTITY as CONTI_NON_RACCORDATI_CEP_ENTITY,
  ENTITY_PLURAL as CONTI_NON_RACCORDATI_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-conti-non-raccordati';
import {
  PERMISSION_ACCESS_ENTITY as CONTO_ECONOMICO_ANNO_PRECEDENTE_ACCESS_PERMISSION,
  ENTITY as CONTO_ECONOMICO_ANNO_PRECEDENTE_ENTITY,
  ENTITY_PLURAL as CONTO_ECONOMICO_ANNO_PRECEDENTE_ENTITY_PLURAL,
} from '@ideapa/app-shared-conto-economico-anno-precedente';
import {
  PERMISSION_ACCESS_ENTITY as CONTROLLO_COSTI_PER_MISSIONE_CEP_ACCESS_PERMISSION,
  ENTITY as CONTROLLO_COSTI_PER_MISSIONE_CEP_ENTITY,
  ENTITY_PLURAL as CONTROLLO_COSTI_PER_MISSIONE_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-controllo-costi-per-missione';
import {
  PERMISSION_ACCESS_ENTITY as CONTROLLO_SALDI_CEP_ACCESS_PERMISSION,
  ENTITY as CONTROLLO_SALDI_CEP_ENTITY,
  ENTITY_PLURAL as CONTROLLO_SALDI_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-controllo-saldi';
import {
  PERMISSION_ACCESS_ENTITY as COSTI_PER_MISSIONE_ACCESS_PERMISSION,
  ENTITY as COSTI_PER_MISSIONE_ENTITY,
  ENTITY_PLURAL as COSTI_PER_MISSIONE_ENTITY_PLURAL,
} from '@ideapa/app-shared-costi-per-missione';
import {
  PERMISSION_ACCESS_ENTITY as DEFINIZIONE_GAP_PERIMETRO_ACCESS_PERMISSION,
  ENTITY as DEFINIZIONE_GAP_PERIMETRO_ENTITY,
  ENTITY_PLURAL as DEFINIZIONE_GAP_PERIMETRO_ENTITY_PLURAL,
} from '@ideapa/app-shared-definizione-gap-perimetro';
import {
  PERMISSION_ACCESS_ENTITY as DOCUMENTO_PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as DOCUMENTO_PARTECIPATA_ENTITY,
  ENTITY_PLURAL as DOCUMENTO_PARTECIPATA_ENTITY_PLURAL,
} from '@ideapa/app-shared-documento-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as ENTE_ACCESS_PERMISSION,
  ENTITY as ENTE_ENTITY,
  ENTITY_PLURAL as ENTE_ENTITY_PLURAL,
} from '@ideapa/app-shared-ente';
import {
  PERMISSION_ACCESS_ENTITY as GAP_ACCESS_PERMISSION,
  ENTITY as GAP_ENTITY,
  ENTITY_PLURAL as GAP_ENTITY_PLURAL,
} from '@ideapa/app-shared-gap';
import {
  PERMISSION_ACCESS_ENTITY as IMPORTAZIONE_SCRITTURE_ACCESS_PERMISSION,
  ENTITY as IMPORTAZIONE_SCRITTURE_ENTITY,
  ENTITY_PLURAL as IMPORTAZIONE_SCRITTURE_ENTITY_PLURAL,
} from '@ideapa/app-shared-importazione-scritture';
import {
  PERMISSION_ACCESS_ENTITY as INCARICO_PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as INCARICO_PARTECIPATA_ENTITY,
  ENTITY_PLURAL as INCARICO_PARTECIPATA_ENTITY_PLURAL,
} from '@ideapa/app-shared-incarico-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as MATRICE_ACCESS_PERMISSION,
  ENTITY as MATRICE_ENTITY,
} from '@ideapa/app-shared-matrice';
import {
  PERMISSION_ACCESS_ENTITY as MISSIONE_ACCESS_PERMISSION,
  ENTITY as MISSIONE_ENTITY,
  ENTITY_PLURAL as MISSIONE_ENTITY_PLURAL,
} from '@ideapa/app-shared-missione';
import {
  PERMISSION_ACCESS_ENTITY as MODELLO_CONTABILE_ACCESS_PERMISSION,
  ENTITY as MODELLO_CONTABILE_ENTITY,
  ENTITY_PLURAL as MODELLO_CONTABILE_ENTITY_PLURAL,
} from '@ideapa/app-shared-modello-contabile';
import {
  PERMISSION_ACCESS_ENTITY as MODELLO_CONTABILE_RIGA_ACCESS_PERMISSION,
  ENTITY as MODELLO_CONTABILE_RIGA_ENTITY,
  ENTITY_PLURAL as MODELLO_CONTABILE_RIGA_ENTITY_PLURAL,
} from '@ideapa/app-shared-modello-contabile-riga';
import { ENTITY as MODULO_ENTE_ENTITY } from '@ideapa/app-shared-modulo-ente';
import {
  PERMISSION_ACCESS_ENTITY as MOLTIPLICATORE_ACCESS_PERMISSION,
  ENTITY as MOLTIPLICATORE_ENTITY,
  ENTITY_PLURAL as MOLTIPLICATORE_ENTITY_PLURAL,
} from '@ideapa/app-shared-moltiplicatore';
import {
  PERMISSION_ACCESS_ENTITY as NOTA_INTEGRATIVA_CEP_ACCESS_PERMISSION,
  ENTITY as NOTA_INTEGRATIVA_CEP_ENTITY,
  ENTITY_PLURAL as NOTA_INTEGRATIVA_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-nota-integrativa-cep';
import {
  PERMISSION_ACCESS_ENTITY as PARAMETRO_GAP_ACCESS_PERMISSION,
  ENTITY as PARAMETRO_GAP_ENTITY,
  ENTITY_PLURAL as PARAMETRO_GAP_ENTITY_PLURAL,
} from '@ideapa/app-shared-parametro-gap';
import {
  PERMISSION_ACCESS_ENTITY as PARAMETRO_PERIMETRO_ACCESS_PERMISSION,
  ENTITY as PARAMETRO_PERIMETRO_ENTITY,
  ENTITY_PLURAL as PARAMETRO_PERIMETRO_ENTITY_PLURAL,
} from '@ideapa/app-shared-parametro-perimetro';
import {
  PERMISSION_ACCESS_ENTITY as PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as PARTECIPATA_ENTITY,
  ENTITY_PLURAL as PARTECIPATA_ENTITY_PLURAL,
} from '@ideapa/app-shared-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as PARTECIPATA_ENTE_ACCESS_PERMISSION,
  ENTITY as PARTECIPATA_ENTE_ENTITY,
} from '@ideapa/app-shared-partecipata-ente';
import {
  PERMISSION_ACCESS_ENTITY as PARTECIPATA_SERVIZIO_ACCESS_PERMISSION,
  ENTITY as PARTECIPATA_SERVIZIO_ENTITY,
  ENTITY_PLURAL as PARTECIPATA_SERVIZIO_ENTITY_PLURAL,
} from '@ideapa/app-shared-partecipata-servizio';
import {
  PERMISSION_ACCESS_ENTITY as PERIMETRO_ACCESS_PERMISSION,
  ENTITY as PERIMETRO_ENTITY,
  ENTITY_PLURAL as PERIMETRO_ENTITY_PLURAL,
} from '@ideapa/app-shared-perimetro';
import {
  PERMISSION_ACCESS_ENTITY as PIANO_CONTI_ACCESS_PERMISSION,
  ENTITY as PIANO_CONTI_ENTITY,
} from '@ideapa/app-shared-piano-conti';
import {
  PERMISSION_ACCESS_ENTITY as PIANO_FINANZIARIO_ACCESS_PERMISSION,
  ENTITY as PIANO_FINANZIARIO_ENTITY,
} from '@ideapa/app-shared-piano-finanziario';
import {
  PERMISSION_ACCESS_ENTITY as PRIMA_NOTA_ACCESS_PERMISSION,
  ENTITY as PRIMA_NOTA_ENTITY,
  ENTITY_PLURAL as PRIMA_NOTA_ENTITY_PLURAL,
} from '@ideapa/app-shared-prima-nota';
import {
  PERMISSION_ACCESS_ENTITY as PRIMA_NOTA_RIGA_ACCESS_PERMISSION,
  ENTITY as PRIMA_NOTA_RIGA_ENTITY,
  ENTITY_PLURAL as PRIMA_NOTA_RIGA_ENTITY_PLURAL,
} from '@ideapa/app-shared-prima-nota-riga';
import {
  PERMISSION_ACCESS_ENTITY as PROGRAMMA_ACCESS_PERMISSION,
  ENTITY as PROGRAMMA_ENTITY,
  ENTITY_PLURAL as PROGRAMMA_ENTITY_PLURAL,
} from '@ideapa/app-shared-programma';
import {
  PERMISSION_ACCESS_ENTITY as PROSPETTO_ACCESS_PERMISSION,
  ENTITY as PROSPETTO_ENTITY,
  ENTITY_PLURAL as PROSPETTO_ENTITY_PLURAL,
} from '@ideapa/app-shared-prospetto';
import {
  PERMISSION_ACCESS_ENTITY as RACCORDO_ACCESS_PERMISSION,
  ENTITY as RACCORDO_ENTITY,
} from '@ideapa/app-shared-raccordo';
import {
  PERMISSION_ACCESS_ENTITY as RIDUZIONE_PROPORZIONALE_ACCESS_PERMISSION,
  ENTITY as RIDUZIONE_PROPORZIONALE_ENTITY,
  ENTITY_PLURAL as RIDUZIONE_PROPORZIONALE_ENTITY_PLURAL,
} from '@ideapa/app-shared-riduzione-proporzionale';
import {
  PERMISSION_ACCESS_ENTITY as RIEPILOGO_PROSPETTI_ACCESS_PERMISSION,
  ENTITY as RIEPILOGO_PROSPETTI_ENTITY,
  ENTITY_PLURAL as RIEPILOGO_PROSPETTI_ENTITY_PLURAL,
} from '@ideapa/app-shared-riepilogo-prospetti';
import {
  PERMISSION_ACCESS_ENTITY as SALDO_INIZIALE_ACCESS_PERMISSION,
  ENTITY as SALDO_INIZIALE_ENTITY,
  ENTITY_PLURAL as SALDO_INIZIALE_ENTITY_PLURAL,
} from '@ideapa/app-shared-saldo-iniziale';
import {
  PERMISSION_ACCESS_ENTITY as SCRITTURA_ELISIONE_ACCESS_PERMISSION,
  ENTITY as SCRITTURA_ELISIONE_ENTITY,
  ENTITY_PLURAL as SCRITTURA_ELISIONE_ENTITY_PLURAL,
} from '@ideapa/app-shared-scrittura-elisione';
import {
  PERMISSION_ACCESS_ENTITY as SCRITTURA_PRE_CONSOLIDAMENTO_ACCESS_PERMISSION,
  ENTITY as SCRITTURA_PRE_CONSOLIDAMENTO_ENTITY,
  ENTITY_PLURAL as SCRITTURA_PRE_CONSOLIDAMENTO_ENTITY_PLURAL,
} from '@ideapa/app-shared-scrittura-preconsolidamento';
import {
  PERMISSION_ACCESS_ENTITY as SERVIZIO_PUBBLICO_ACCESS_PERMISSION,
  ENTITY as SERVIZIO_PUBBLICO_ENTITY,
  ENTITY_PLURAL as SERVIZIO_PUBBLICO_ENTITY_PLURAL,
} from '@ideapa/app-shared-servizio-pubblico';
import {
  PERMISSION_ACCESS_ENTITY as STAMPE_CEP_ACCESS_PERMISSION,
  ENTITY as STAMPE_CEP_ENTITY,
  ENTITY_PLURAL as STAMPE_CEP_ENTITY_PLURAL,
} from '@ideapa/app-shared-stampe-cep';
import {
  PERMISSION_ACCESS_ENTITY as STAMPE_PARTECIPO_ACCESS_PERMISSION,
  ENTITY as STAMPE_PARTECIPO_ENTITY,
  ENTITY_PLURAL as STAMPE_PARTECIPO_ENTITY_PLURAL,
} from '@ideapa/app-shared-stampe-partecipo';
import {
  PERMISSION_ACCESS_ENTITY as STRUTTURA_PROSPETTO_ACCESS_PERMISSION,
  ENTITY as STRUTTURA_PROSPETTO_ENTITY,
  ENTITY_PLURAL as STRUTTURA_PROSPETTO_ENTITY_PLURAL,
} from '@ideapa/app-shared-struttura-prospetto';
import {
  PERMISSION_ACCESS_ENTITY as TEMPLATE_ACCESS_PERMISSION,
  ENTITY as TEMPLATE_ENTITY,
  ENTITY_PLURAL as TEMPLATE_ENTITY_PLURAL,
} from '@ideapa/app-shared-template';
import {
  PERMISSION_ACCESS_ENTITY as TIPOLOGIA_COMPENSO_ACCESS_PERMISSION,
  ENTITY as TIPOLOGIA_COMPENSO_ENTITY,
  ENTITY_PLURAL as TIPOLOGIA_COMPENSO_ENTITY_PLURAL,
} from '@ideapa/app-shared-tipologia-compenso';
import {
  PERMISSION_ACCESS_ENTITY as TIPOLOGIA_DOCUMENTO_ACCESS_PERMISSION,
  ENTITY as TIPOLOGIA_DOCUMENTO_ENTITY,
  ENTITY_PLURAL as TIPOLOGIA_DOCUMENTO_ENTITY_PLURAL,
} from '@ideapa/app-shared-tipologia-documento';
import {
  PERMISSION_ACCESS_ENTITY as TIPOLOGIA_INCARICO_ACCESS_PERMISSION,
  ENTITY as TIPOLOGIA_INCARICO_ENTITY,
  ENTITY_PLURAL as TIPOLOGIA_INCARICO_ENTITY_PLURAL,
} from '@ideapa/app-shared-tipologia-incarico';
import {
  PERMISSION_ACCESS_ENTITY as TIPOLOGIA_PARTECIPAZIONE_ACCESS_PERMISSION,
  ENTITY as TIPOLOGIA_PARTECIPAZIONE_ENTITY,
  ENTITY_PLURAL as TIPOLOGIA_PARTECIPAZIONE_ENTITY_PLURAL,
} from '@ideapa/app-shared-tipologia-partecipazione';
import {
  PERMISSION_ACCESS_ENTITY as TIPOLOGIA_REGISTRAZIONE_ACCESS_PERMISSION,
  ENTITY as TIPOLOGIA_REGISTRAZIONE_ENTITY,
  ENTITY_PLURAL as TIPOLOGIA_REGISTRAZIONE_ENTITY_PLURAL,
} from '@ideapa/app-shared-tipologia-registrazione';
import {
  PERMISSION_ACCESS_ENTITY as USER_ACCESS_PERMISSION,
  ENTITY as USER_ENTITY,
  ENTITY_PLURAL as USER_ENTITY_PLURAL,
} from '@ideapa/app-shared-utente';
import { ENTITY as UTENTE_ENTE_ENTITY } from '@ideapa/app-shared-utente-ente';
import {
  PERMISSION_ACCESS_ENTITY as UTENTE_PARTECIPATA_ACCESS_PERMISSION,
  ENTITY as UTENTE_PARTECIPATA_ENTITY,
} from '@ideapa/app-shared-utente-partecipata';
import {
  PERMISSION_ACCESS_ENTITY as VALORI_ANNO_PRECEDENTE_ACCESS_PERMISSION,
  ENTITY as VALORI_ANNO_PRECEDENTE_ENTITY,
  ENTITY_PLURAL as VALORI_ANNO_PRECEDENTE_ENTITY_PLURAL,
} from '@ideapa/app-shared-valori-anno-precedente';

// import { environment } from '../environments/environment';

// Dashboard
export const mainDashboardRoute: ExtendedRoute[] = [
  {
    path: 'home',
    label: 'Dashboard',
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-home').then((m) => m.AppLazyHomeModule),
  },
  {
    path: 'notifica',
    label: 'Notifiche',
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-notifica').then((m) => m.AppLazyNotificaModule),
  },
];

// Archivi generali comuni a cep e partecipo
export const archiviRoutes: ExtendedRoute[] = [
  {
    path: MISSIONE_ENTITY,
    label: MISSIONE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, MISSIONE_ACCESS_PERMISSION],
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-missione').then((m) => m.AppLazyMissioneModule),
  },
  {
    path: PROGRAMMA_ENTITY,
    label: PROGRAMMA_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PROGRAMMA_ACCESS_PERMISSION],
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-programma').then(
        (m) => m.AppLazyProgrammaModule
      ),
  },
  {
    path: TIPOLOGIA_REGISTRAZIONE_ENTITY,
    label: TIPOLOGIA_REGISTRAZIONE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      TIPOLOGIA_REGISTRAZIONE_ACCESS_PERMISSION,
    ],
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-tipologia-registrazione').then(
        (m) => m.AppLazyTipologiaRegistrazioneModule
      ),
  },
  {
    path: PROSPETTO_ENTITY,
    label: PROSPETTO_ENTITY_PLURAL,
    menuHidden: false,
    anno: true,
    permissions: [PERMISSION_ACCESS_ALL, PROSPETTO_ACCESS_PERMISSION],
    loadChildren: () =>
      import('@ideapa/app-lazy-prospetto').then(
        (m) => m.AppLazyProspettoModule
      ),
  },
  {
    path: STRUTTURA_PROSPETTO_ENTITY,
    label: STRUTTURA_PROSPETTO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, STRUTTURA_PROSPETTO_ACCESS_PERMISSION],
    // pathMatch: 'full',
    menuHidden: true,
    loadChildren: () =>
      import('@ideapa/app-lazy-struttura-prospetto').then(
        (m) => m.AppLazyStrutturaProspettoModule
      ),
  },
  {
    path: MOLTIPLICATORE_ENTITY,
    label: MOLTIPLICATORE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, MOLTIPLICATORE_ACCESS_PERMISSION],
    loadChildren: () =>
      import('@ideapa/app-lazy-moltiplicatore').then(
        (m) => m.AppLazyMoltiplicatoreModule
      ),
  },
  {
    path: TEMPLATE_ENTITY,
    label: TEMPLATE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, TEMPLATE_ACCESS_PERMISSION],
    loadChildren: () =>
      import('@ideapa/app-lazy-template').then((m) => m.AppLazyTemplateModule),
  },
];

// Amministrazione
export const adminRoutes: ExtendedRoute[] = [
  {
    path: USER_ENTITY,
    label: USER_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, USER_ACCESS_PERMISSION],
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-utente').then((m) => m.AppLazyUtenteModule),
  },
  {
    path: ENTE_ENTITY,
    label: ENTE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, ENTE_ACCESS_PERMISSION],
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-ente').then((m) => m.AppLazyEnteModule),
  },
  {
    path: UTENTE_ENTE_ENTITY,
    label: '',
    menuHidden: true,
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-utente-ente').then(
        (m) => m.AppLazyUtenteEnteModule
      ),
  },
  {
    path: MODULO_ENTE_ENTITY,
    label: '',
    menuHidden: true,
    // pathMatch: 'full',
    loadChildren: () =>
      import('@ideapa/app-lazy-modulo-ente').then(
        (m) => m.AppLazyModuloEnteModule
      ),
  },
];

// Partecipo
export const gestionePartecipateRoutes: ExtendedRoute[] = [
  {
    path: PARTECIPATA_ENTITY,
    label: PARTECIPATA_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PARTECIPATA_ACCESS_PERMISSION],
    ente: false, // accede anche utente partecipata senza selezionare ente
    menuHidden: false,
    anno: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-partecipata').then(
        (m) => m.AppLazyPartecipataModule
      ),
  },
  {
    path: BILANCIO_ENTE_ENTITY,
    label: 'Gestione Bilancio Ente',
    permissions: [PERMISSION_ACCESS_ALL, BILANCIO_ENTE_ACCESS_PERMISSION],
    ente: true,
    menuHidden: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-ente').then(
        (m) => m.AppLazyBilancioEnteModule
      ),
  },
  {
    path: BILANCIO_ENTE_RIGA_ENTITY,
    label: 'Bilancio Ente Riga',
    permissions: [PERMISSION_ACCESS_ALL, BILANCIO_ENTE_RIGA_ACCESS_PERMISSION],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-ente-riga').then(
        (m) => m.AppLazyBilancioEnteRigaModule
      ),
  },
  {
    path: PARTECIPATA_ENTE_ENTITY,
    label: '',
    permissions: [PERMISSION_ACCESS_ALL, PARTECIPATA_ENTE_ACCESS_PERMISSION],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-partecipata-ente').then(
        (m) => m.AppLazyPartecipataEnteModule
      ),
  },
  {
    path: UTENTE_PARTECIPATA_ENTITY,
    label: '',
    permissions: [PERMISSION_ACCESS_ALL, UTENTE_PARTECIPATA_ACCESS_PERMISSION],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-utente-partecipata').then(
        (m) => m.AppLazyUtentePartecipataModule
      ),
  },
  {
    path: ATTIVITA_PARTECIPATA_ENTITY,
    label: ATTIVITA_PARTECIPATA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      ATTIVITA_PARTECIPATA_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-attivita-partecipata').then(
        (m) => m.AppLazyAttivitaPartecipataModule
      ),
  },
  {
    path: PARTECIPATA_SERVIZIO_ENTITY,
    label: PARTECIPATA_SERVIZIO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      PARTECIPATA_SERVIZIO_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-partecipata-servizio').then(
        (m) => m.AppLazyPartecipataServizioModule
      ),
  },
  {
    path: DOCUMENTO_PARTECIPATA_ENTITY,
    label: DOCUMENTO_PARTECIPATA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      DOCUMENTO_PARTECIPATA_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-documento-partecipata').then(
        (m) => m.AppLazyDocumentoPartecipataModule
      ),
  },
  {
    path: INCARICO_PARTECIPATA_ENTITY,
    label: INCARICO_PARTECIPATA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      INCARICO_PARTECIPATA_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-incarico-partecipata').then(
        (m) => m.AppLazyIncaricoPartecipataModule
      ),
  },

  {
    path: COMPAGINE_SOCIALE_ENTITY,
    label: COMPAGINE_SOCIALE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, COMPAGINE_SOCIALE_ACCESS_PERMISSION],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-compagine-sociale').then(
        (m) => m.AppLazyCompagineSocialeModule
      ),
  },
  {
    path: BILANCIO_PARTECIPATA_ENTITY,
    label: BILANCIO_PARTECIPATA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      BILANCIO_PARTECIPATA_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true, // se si rende visibile allora è necessario modificare il comportamento associato al cambio di valore selezionato nella combo anno (vedere componente lista)
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-partecipata').then(
        (m) => m.AppLazyBilancioPartecipataModule
      ),
  },
  {
    path: BILANCIO_PARTECIPATA_RIGA_ENTITY,
    label: BILANCIO_PARTECIPATA_RIGA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      BILANCIO_PARTECIPATA_RIGA_ACCESS_PERMISSION,
    ],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-partecipata-riga').then(
        (m) => m.AppLazyBilancioPartecipataRigaModule
      ),
  },
  {
    path: ANALISI_BILANCIO_ENTITY,
    label: ANALISI_BILANCIO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, ANALISI_BILANCIO_ACCESS_PERMISSION],
    ente: true,
    menuHidden: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-analisi-bilancio').then(
        (m) => m.AppLazyAnalisiBilancioModule
      ),
  },
];

// bilancio consolidato
export const bilancioConsolidatoPartecipoRoutes: ExtendedRoute[] = [
  {
    path: DEFINIZIONE_GAP_PERIMETRO_ENTITY,
    label: DEFINIZIONE_GAP_PERIMETRO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      DEFINIZIONE_GAP_PERIMETRO_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-definizione-gap-perimetro').then(
        (m) => m.AppLazyDefinizioneGapPerimetroModule
      ),
  },
  {
    path: GAP_ENTITY,
    label: GAP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, GAP_ACCESS_PERMISSION],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: true,
    loadChildren: () =>
      import('@ideapa/app-lazy-gap').then((m) => m.AppLazyGapModule),
  },
  {
    path: PERIMETRO_ENTITY,
    label: PERIMETRO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PERIMETRO_ACCESS_PERMISSION],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: true,
    loadChildren: () =>
      import('@ideapa/app-lazy-perimetro').then(
        (m) => m.AppLazyPerimetroModule
      ),
  },
  {
    path: SCRITTURA_PRE_CONSOLIDAMENTO_ENTITY,
    label: SCRITTURA_PRE_CONSOLIDAMENTO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      SCRITTURA_PRE_CONSOLIDAMENTO_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: false,
    loadChildren: () =>
      import('@ideapa/app-lazy-scrittura-preconsolidamento').then(
        (m) => m.AppLazyScritturaPreconsolidamentoModule
      ),
  },
  {
    path: RIDUZIONE_PROPORZIONALE_ENTITY,
    label: RIDUZIONE_PROPORZIONALE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      RIDUZIONE_PROPORZIONALE_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-riduzione-proporzionale').then(
        (m) => m.AppLazyRiduzioneProporzionaleModule
      ),
  },
  {
    path: SCRITTURA_ELISIONE_ENTITY,
    label: SCRITTURA_ELISIONE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, SCRITTURA_ELISIONE_ACCESS_PERMISSION],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: false,
    loadChildren: () =>
      import('@ideapa/app-lazy-scrittura-elisione').then(
        (m) => m.AppLazyScritturaElisioneModule
      ),
  },
  {
    path: BILANCIO_CONSOLIDATO_ENTITY,
    label: BILANCIO_CONSOLIDATO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      BILANCIO_CONSOLIDATO_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: false,
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-consolidato').then(
        (m) => m.AppLazyBilancioConsolidatoModule
      ),
  },
  {
    path: BILANCIO_CONSOLIDATO_RIGA_ENTITY,
    label: BILANCIO_CONSOLIDATO_RIGA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      BILANCIO_CONSOLIDATO_RIGA_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: true,
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-consolidato-riga').then(
        (m) => m.AppLazyBilancioConsolidatoRigaModule
      ),
  },
  {
    path: BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ENTITY,
    label: BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      BILANCIO_CONSOLIDATO_RIGA_DETTAGLIO_ACCESS_PERMISSION,
    ],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: true,
    loadChildren: () =>
      import('@ideapa/app-lazy-bilancio-consolidato-riga-dettaglio').then(
        (m) => m.AppLazyBilancioConsolidatoRigaDettaglioModule
      ),
  },
  {
    path: STAMPE_PARTECIPO_ENTITY,
    label: STAMPE_PARTECIPO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, STAMPE_PARTECIPO_ACCESS_PERMISSION],
    ente: true,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    menuHidden: false,
    loadChildren: () =>
      import('@ideapa/app-lazy-stampe-partecipo').then(
        (m) => m.AppLazyStampePartecipoModule
      ),
  },
];

// archivi generali
export const archiviPartecipateRoutes: ExtendedRoute[] = [
  {
    path: TIPOLOGIA_INCARICO_ENTITY,
    label: TIPOLOGIA_INCARICO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, TIPOLOGIA_INCARICO_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-tipologia-incarico').then(
        (m) => m.AppLazyTipologiaIncaricoModule
      ),
  },
  {
    path: TIPOLOGIA_PARTECIPAZIONE_ENTITY,
    label: TIPOLOGIA_PARTECIPAZIONE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      TIPOLOGIA_PARTECIPAZIONE_ACCESS_PERMISSION,
    ],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-tipologia-partecipazione').then(
        (m) => m.AppLazyTipologiaPartecipazioneModule
      ),
  },
  {
    path: TIPOLOGIA_DOCUMENTO_ENTITY,
    label: TIPOLOGIA_DOCUMENTO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, TIPOLOGIA_DOCUMENTO_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-tipologia-documento').then(
        (m) => m.AppLazyTipologiaDocumentoModule
      ),
  },
  {
    path: TIPOLOGIA_COMPENSO_ENTITY,
    label: TIPOLOGIA_COMPENSO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, TIPOLOGIA_COMPENSO_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-tipologia-compenso').then(
        (m) => m.AppLazyTipologiaCompensoModule
      ),
  },
  {
    path: SERVIZIO_PUBBLICO_ENTITY,
    label: SERVIZIO_PUBBLICO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, SERVIZIO_PUBBLICO_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-servizio-pubblico').then(
        (m) => m.AppLazyServizioPubblicoModule
      ),
  },
  // {
  //   path: MOLTIPLICATORE_ENTITY,
  //   label: MOLTIPLICATORE_ENTITY_PLURAL,
  //   permissions: [PERMISSION_ACCESS_ALL, MOLTIPLICATORE_ACCESS_PERMISSION],
  //   ente: false,
  //   // pathMatch: 'full',
  //   modulo: 'Partecipo',
  //   loadChildren: () =>
  //     import('@ideapa/app-lazy-moltiplicatore').then(
  //       (m) => m.AppLazyMoltiplicatoreModule
  //     ),
  // },
  {
    path: PARAMETRO_GAP_ENTITY,
    label: PARAMETRO_GAP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PARAMETRO_GAP_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-parametro-gap').then(
        (m) => m.AppLazyParametroGapModule
      ),
  },
  {
    path: PARAMETRO_PERIMETRO_ENTITY,
    label: PARAMETRO_PERIMETRO_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PARAMETRO_PERIMETRO_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-parametro-perimetro').then(
        (m) => m.AppLazyParametroPerimetroModule
      ),
  },
  {
    path: MODELLO_CONTABILE_ENTITY,
    label: MODELLO_CONTABILE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, MODELLO_CONTABILE_ACCESS_PERMISSION],
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-modello-contabile').then(
        (m) => m.AppLazyModelloContabileModule
      ),
  },
  {
    path: MODELLO_CONTABILE_RIGA_ENTITY,
    label: MODELLO_CONTABILE_RIGA_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      MODELLO_CONTABILE_RIGA_ACCESS_PERMISSION,
    ],
    menuHidden: true,
    ente: false,
    // pathMatch: 'full',
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-modello-contabile-riga').then(
        (m) => m.AppLazyModelloContabileRigaModule
      ),
  },
];

export const utilityPartecipoRoutes: ExtendedRoute[] = [
  {
    path: VALORI_ANNO_PRECEDENTE_ENTITY,
    label: VALORI_ANNO_PRECEDENTE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      VALORI_ANNO_PRECEDENTE_ACCESS_PERMISSION,
    ],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-valori-anno-precedente').then(
        (m) => m.AppLazyValoriAnnoPrecedenteModule
      ),
  },
  {
    path: IMPORTAZIONE_SCRITTURE_ENTITY,
    label: IMPORTAZIONE_SCRITTURE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      IMPORTAZIONE_SCRITTURE_ACCESS_PERMISSION,
    ],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-importazione-scritture').then(
        (m) => m.AppLazyImportazioneScrittureModule
      ),
  },
  {
    path: CANCELLAZIONI_PARTECIPO_ENTITY,
    label: CANCELLAZIONI_PARTECIPO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CANCELLAZIONI_PARTECIPO_ACCESS_PERMISSION,
    ],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-cancellazioni-partecipo').then(
        (m) => m.AppLazyCancellazioniPartecipoModule
      ),
  },
  {
    path: CHIUSURA_RIPRISTINO_CONSOLIDATO_ENTITY,
    label: CHIUSURA_RIPRISTINO_CONSOLIDATO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CHIUSURA_RIPRISTINO_CONSOLIDATO_ACCESS_PERMISSION,
    ],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Partecipo',
    loadChildren: () =>
      import('@ideapa/app-lazy-chiusura-ripristino-consolidato').then(
        (m) => m.AppLazyChiusuraRipristinoConsolidatoModule
      ),
  },
];

// Cep
// gestione Cep
export const gestioneCepRoutes: ExtendedRoute[] = [
  {
    path: PIANO_FINANZIARIO_ENTITY,
    label: 'Piano finanziario',
    permissions: [PERMISSION_ACCESS_ALL, PIANO_FINANZIARIO_ACCESS_PERMISSION],
    // pathMatch: 'full',
    ente: false,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-piano-finanziario').then(
        (m) => m.AppLazyPianoFinanziarioModule
      ),
  },
  {
    path: PIANO_CONTI_ENTITY,
    label: 'Piano dei Conti',
    permissions: [PERMISSION_ACCESS_ALL, PIANO_CONTI_ACCESS_PERMISSION],
    // pathMatch: 'full',
    ente: false,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-piano-conti').then(
        (m) => m.AppLazyPianoContiModule
      ),
  },
];

// Cep
export const gestioneEnteRoutes: ExtendedRoute[] = [
  {
    path: MATRICE_ENTITY,
    label: 'Matrice di Correlazione',
    permissions: [PERMISSION_ACCESS_ALL, MATRICE_ACCESS_PERMISSION],
    // pathMatch: 'full',
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-matrice').then((m) => m.AppLazyMatriceModule),
  },
  {
    path: RACCORDO_ENTITY,
    label: 'Raccordo Conti-Prospetti',
    permissions: [PERMISSION_ACCESS_ALL, RACCORDO_ACCESS_PERMISSION],
    // pathMatch: 'full',
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-raccordo').then((m) => m.AppLazyRaccordoModule),
  },
  {
    path: SALDO_INIZIALE_ENTITY,
    label: SALDO_INIZIALE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, SALDO_INIZIALE_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-saldo-iniziale').then(
        (m) => m.AppLazySaldoInizialeModule
      ),
  },

  {
    path: COFI_ENTITY,
    label: COFI_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, COFI_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-cofi').then((m) => m.AppLazyCofiModule),
  },
  {
    path: PRIMA_NOTA_ENTITY,
    label: PRIMA_NOTA_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PRIMA_NOTA_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-prima-nota').then(
        (m) => m.AppLazyPrimaNotaModule
      ),
  },
  {
    path: PRIMA_NOTA_RIGA_ENTITY,
    label: PRIMA_NOTA_RIGA_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, PRIMA_NOTA_RIGA_ACCESS_PERMISSION],
    menuHidden: true,
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-prima-nota-riga').then(
        (m) => m.AppLazyPrimaNotaRigaModule
      ),
  },
  {
    path: RIEPILOGO_PROSPETTI_ENTITY,
    label: RIEPILOGO_PROSPETTI_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, RIEPILOGO_PROSPETTI_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-riepilogo-prospetti').then(
        (m) => m.AppLazyRiepilogoProspettiModule
      ),
  },
  {
    path: STAMPE_CEP_ENTITY,
    label: STAMPE_CEP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, STAMPE_CEP_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    // menuHidden: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-stampe-cep').then(
        (m) => m.AppLazyStampeCepModule
      ),
  },
  {
    path: COSTI_PER_MISSIONE_ENTITY,
    label: COSTI_PER_MISSIONE_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, COSTI_PER_MISSIONE_ACCESS_PERMISSION],
    menuHidden: true,
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-costi-per-missione').then(
        (m) => m.AppLazyCostiPerMissioneModule
      ),
  },
  {
    path: ACCRUAL_CEP_ENTITY,
    label: ACCRUAL_CEP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, ACCRUAL_CEP_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    // menuHidden: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-accrual-cep').then(
        (m) => m.AppLazyAccrualCepModule
      ),
  },
];

export const utilityCepRoutes: ExtendedRoute[] = [
  {
    path: CONTO_ECONOMICO_ANNO_PRECEDENTE_ENTITY,
    label: CONTO_ECONOMICO_ANNO_PRECEDENTE_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CONTO_ECONOMICO_ANNO_PRECEDENTE_ACCESS_PERMISSION,
    ],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-conto-economico-anno-precedente').then(
        (m) => m.AppLazyContoEconomicoAnnoPrecedenteModule
      ),
  },
  {
    path: BDAP_CEP_ENTITY,
    label: BDAP_CEP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, BDAP_CEP_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-bdap-cep').then((m) => m.AppLazyBdapCepModule),
  },
  {
    path: CONTROLLO_COSTI_PER_MISSIONE_CEP_ENTITY,
    label: CONTROLLO_COSTI_PER_MISSIONE_CEP_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CONTROLLO_COSTI_PER_MISSIONE_CEP_ACCESS_PERMISSION,
    ],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-controllo-costi-per-missione').then(
        (m) => m.AppLazyControlloCostiPerMissioneModule
      ),
  },
  {
    path: CONTROLLO_SALDI_CEP_ENTITY,
    label: CONTROLLO_SALDI_CEP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, CONTROLLO_SALDI_CEP_ACCESS_PERMISSION],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-controllo-saldi').then(
        (m) => m.AppLazyControlloSaldiModule
      ),
  },
  {
    path: CONTI_NON_RACCORDATI_CEP_ENTITY,
    label: CONTI_NON_RACCORDATI_CEP_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CONTI_NON_RACCORDATI_CEP_ACCESS_PERMISSION,
    ],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-conti-non-raccordati').then(
        (m) => m.AppLazyContiNonRaccordatiModule
      ),
  },
  {
    path: CHIUSURA_RIPRISTINO_ESERCIZIO_ENTITY,
    label: CHIUSURA_RIPRISTINO_ESERCIZIO_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      CHIUSURA_RIPRISTINO_ESERCIZIO_ACCESS_PERMISSION,
    ],
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-chiusura-ripristino-esercizio').then(
        (m) => m.AppLazyChiusuraRipristinoEsercizioModule
      ),
  },
  {
    path: NOTA_INTEGRATIVA_CEP_ENTITY,
    label: NOTA_INTEGRATIVA_CEP_ENTITY_PLURAL,
    permissions: [
      PERMISSION_ACCESS_ALL,
      NOTA_INTEGRATIVA_CEP_ACCESS_PERMISSION,
    ],
    // menuHidden: true,
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-nota-integrativa-cep').then(
        (m) => m.AppLazyNotaIntegrativaCepModule
      ),
  },
  {
    path: CANCELLAZIONI_CEP_ENTITY,
    label: CANCELLAZIONI_CEP_ENTITY_PLURAL,
    permissions: [PERMISSION_ACCESS_ALL, CANCELLAZIONI_CEP_ACCESS_PERMISSION],
    menuHidden: false,
    ente: true,
    anno: true,
    modulo: 'Cep',
    loadChildren: () =>
      import('@ideapa/app-lazy-cancellazioni-cep').then(
        (m) => m.AppLazyCancellazioniCepModule
      ),
  },
];

export const allRoutes = [
  ...mainDashboardRoute,
  ...adminRoutes,
  ...archiviRoutes,
  ...gestioneCepRoutes,
  ...gestioneEnteRoutes,
  ...utilityCepRoutes,
  ...gestionePartecipateRoutes,
  ...archiviPartecipateRoutes,
  ...bilancioConsolidatoPartecipoRoutes,
  ...utilityPartecipoRoutes,
];
